<template>
  <div style="height: 600px;">
    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">请输入要查询的车辆信息
                              计费标准： 4 元/次</span>
    </div>
    <div class="checkAll">
      <Input v-model="carNum" placeholder="请输入车牌号" style="width: 200px;margin-left: 5px"/>
      <Select v-model="carCorlor" placeholder="车牌颜色" style="width: 200px;margin-left: 5px">
        <Option v-for="(item,index) in colorType" :value="item.value" :key="index">{{ item.label }}</Option>
      </Select>
      <Button status="primary" icon="ios-search" style="margin-left: 10px;border-radius: 5px;" @click="commit">搜索</Button>
    </div>

    <div style="height: 30px;width: 100%;background: #EFF3F3">
      <span style="font-size: 12px;margin-left: 20px;text-align: center;line-height: 30px;">查询结果</span>
    </div>
    <div class="resultFive">{{resultFive}}</div>
  </div>
</template>
<script>
  import {apiGet} from "../../utils/api";
  import {hideLoading, showLoading} from "@/utils/util";

  export default {
    name: 'checkDL',
    data() {
      return {
        carNum: '',
        carCorlor: '',
        resultFive: '',
        colorType: [
          {
            value: 2,
            label: "黄牌"
          },
          {
            value: 1,
            label: "蓝牌"
          }
        ],
      }
    },
    methods: {
      commit() {
        let self = this;
        //提示填写信息
        if (!this.carNum || !this.carCorlor) {
          this.$XModal.alert({
            message: '请输入完整信息！',
            status: "error",
          });
          return;
        }
        this.$XModal.confirm("请确认信息无误，确认后将付费查询").then((type) => {
          if (type === "confirm") {
            this.vehicleInfoCompleteV21();
          }
        });
      },
      async vehicleInfoCompleteV21() {
        let params = {
          method: 'vehicleInfoCompleteV21',
          params: {
            vclNs: this.carNum + '_' + this.carCorlor,
          }
        }
        showLoading();
        // let res = {
        //   "result":
        //     [{
        //       "ldTn": "11990",
        //       "vclLng": "9600",
        //       "vclWdt": "2380",
        //       "enTn": "12130",
        //       "carType": " 货 五 ",
        //       "vclTn": "24315",
        //       "clDrwTn": "24315",
        //       "engine": "A44D1711878",
        //       "pltClr": "2",
        //       "vclHgt": "800",
        //       "vclN": "云 E17361",
        //       "state": 1001,
        //       "vclAxs": "4",
        //       "vclBrand": "大地牌RX5240ECCQB",
        //       "vclTyreNumber": "10",
        //       "vehicleType": " 重 型 仓 栅 式 货 车",
        //       "drivingLicenseRegisterDate": "20100322",
        //       "dateOfissue": "20160523",
        //       "natureOfUsage": "货运",
        //       "vin": " LGF19AJLXDF5390876",
        //       "areaName": "云南省昆明市"
        //     }],
        //   "status": 1001
        // }
        let res = await apiGet("api/order/track/", params.method, params.params);
        hideLoading();
        if (res && res.status === 1) {
          let resData = JSON.parse(res.data)
          if (resData.status === 1001) {
            let data = resData.result[0];
            let vclN = data.vclN ? data.vclN : '';//车牌号
            let pltClr = '';//车牌颜色
            if (data.pltClr) {
              if (data.pltClr === '1') {
                pltClr = '蓝'
              } else if (data.pltClr === '2') {
                pltClr = '黄'
              }
            }
            let vclTn = data.vclTn ? data.vclTn : '';//总质量
            let clDrwTn = data.clDrwTn ? data.clDrwTn : '';//准牵引质量
            let ldTn = data.ldTn ? data.ldTn : '';//额定载质量
            let enTn = data.enTn ? data.enTn : '';//整备质量
            let vclAxs = data.vclAxs ? data.vclAxs : '';//轴数
            let vclLng = data.vclLng ? data.vclLng : '';//外廓长
            let vclWdt = data.vclWdt ? data.vclWdt : '';//外廓宽
            let vclHgt = data.vclHgt ? data.vclHgt : '';//外廓高
            let carType = '';//货车分类
            if (data.carType) {
              if (data.carType === 1) {
                carType = '货一'
              } else if (data.carType === 2) {
                carType = '货二'
              } else if (data.carType === 3) {
                carType = '货三'
              } else if (data.carType === 4) {
                carType = '货四'
              } else if (data.carType === 5) {
                carType = '货五'
              }
            }
            let vclBrand = data.vclBrand ? data.vclBrand : '';//品牌型号
            let drivingLicenseRegisterDate = data.drivingLicenseRegisterDate ? data.drivingLicenseRegisterDate : '';//行驶证注册日期
            let dateOfissue = data.dateOfissue ? data.dateOfissue : '';//行驶证发证日期
            let engine = data.engine ? data.engine : '';//发动机号
            let vehicleType = data.vehicleType ? data.vehicleType : '';//车辆类型
            let vclTyreNumber = data.vclTyreNumber ? data.vclTyreNumber : '';//车轮数
            let natureOfUsage = data.natureOfUsage ? data.natureOfUsage : '';//使用性质
            let vin = data.vin ? data.vin : '';//车架号
            let areaName = data.areaName ? data.areaName : '';//车籍地
            this.resultFive = "车牌号：" + vclN + '\n车牌颜色：' + pltClr +
              '\n总质量：' + vclTn + '\t\t准牵引质量：' + clDrwTn + '\t\t额定载质量:' + ldTn + '\t\t整备质量:' + enTn +
              '\n轴数:' + vclAxs + '\t\t外廓长:' + vclLng + '\t\t外廓宽:' + vclWdt + '\t\t外廓高:' + vclHgt +
              '\n货车分类:' + carType + '\t\t品牌型号:' + vclBrand +
              '\n行驶证注册日期:' + drivingLicenseRegisterDate + '\t\t行驶证发证日期:' + dateOfissue + '\t\t发动机号:' + engine +
              '\n车辆类型:' + vehicleType + '\t\t车轮数:' + vclTyreNumber + '\t\t使用性质:' + natureOfUsage +
              '\n车架号:' + vin + '\t\t车籍地:' + areaName;
          } else if (res.status === 1006) {
            this.resultFive = "无结果";
          } else {
            this.resultFive = "查询错误";
          }
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : '接口异常',
            status: "error",
          });
        }
      },
    }
  }
</script>
<style scoped>
  .checkAll {
    height: 40%;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
  }

  .resultFive {
    /*height: 20%;*/
    margin-top: 10px;
    line-height: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 80px;
    white-space: pre;
  }
</style>